import { render, staticRenderFns } from "./ContactCall.vue?vue&type=template&id=2287b91a&scoped=true&"
import script from "./ContactCall.vue?vue&type=script&lang=ts&"
export * from "./ContactCall.vue?vue&type=script&lang=ts&"
import style0 from "./ContactCall.vue?vue&type=style&index=0&id=2287b91a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2287b91a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VTooltip})
